import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../PageShell";
import { Reveal, TiltCard } from "../UIKit";

const gtm = [
  { title: "Partner with local installers", body: "CCTV and intercom vendors already inside these societies bundle Bellboy in with hardware they're already selling." },
  { title: "Design for guards first", body: "Voice-to-text logging, regional-language interfaces, and simple icons — built for the person using the app dozens of times a day." },
  { title: "Get built into new townships", body: "Direct tie-ups with regional developers mean Bellboy is pre-installed before residents even move in." },
  { title: "Add a local marketplace later", body: "Grocers, water-tanker operators, and domestic-help services listed directly for residents to book." },
];

export default function ApproachPage({ onAuthClick }) {
  return (
    <PageShell
      onAuthClick={onAuthClick}
      eyebrow="Go-to-market"
      title="How we reach new societies."
      lede="Distribution in Tier-2/3 India runs on local trust and physical presence, not app-store ads."
      sceneMode="path"
      sceneData={gtm}
      seoTitle="Approach — Bellboy Security & Society Management App"
      seoDescription="Bellboy's go-to-market approach: installer partnerships, guard-first design, new-township integration, and a future local marketplace."
    >
      <section className="page-section">
        <div className="gtm-grid">
          {gtm.map((g, i) => (
            <Reveal key={g.title} delay={i * 100}>
              <TiltCard className="gtm-card">
                <h3>{g.title}</h3>
                <p>{g.body}</p>
              </TiltCard>
            </Reveal>
          ))}
        </div>
        <Reveal delay={140}>
          <Link to="/about" className="section-btn">Meet the founder →</Link>
        </Reveal>
      </section>
    </PageShell>
  );
}
